import { useEffect } from "react";

export default function BlockBackNavigation() {
	useEffect(() => {
		const blockBackNavigation = () => {
			history.pushState(null, "", window.location.href);
		};

		blockBackNavigation();

		const handlePopState = () => {
			blockBackNavigation();
			alert("Back navigation is disabled on this page.");
		};

		window.addEventListener("popstate", handlePopState);

		return () => {
			window.removeEventListener("popstate", handlePopState);
		};
	}, []);

	return null;
}
